import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tag: {
    page: 0,
    size: 10,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: '',
  },
}

const mapSchemaSlice = createSlice({
  name: 'mapSchema',
  initialState,
  reducers: {
    setFetchOption(state, action) {
      state.tag = {
        ...state.tag,
        ...action.payload,
      }
    },
    resetFetchOption(state) {
      state.tag = initialState.tag
    },
  },
})

export const { setFetchOption, resetFetchOption } = mapSchemaSlice.actions

export default mapSchemaSlice.reducer
